module.exports = __webpack_public_path__ + "static/media/island1.dca3b04e.svg";